export default __webpack_public_path__ + "static/media/4.487a5046.jpeg";